'use client';

import styles from './faqs-page.module.scss';
import { useTranslation } from '@/hook';
import Typography from '@/components/shared/typography/typography.component';
import Questions from './questions.component';

export default function FAQ() {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.banner}>
        <Typography variant="h5Bold">{t('Sylndr FAQs')}</Typography>
      </div>
      <Questions />
    </>
  );
}
